import Component from '../../js/lib/component';
import $ from 'jquery';
import Vue from 'vue/dist/vue.common';
import store from '../../js/Store';

const classList = {
  root: '.js-cart-footer'
};

class CartFooter extends Component {
  init() {
    new Vue({
      name: 'CartFooter',
      el: this.$.root.get(0),
      store,
      computed: {
        cost() {
          return store.getters.cost;
        }
      }
    });
  }
}

export default Component.mount(CartFooter, {
  name: 'CartFooter',
  classList
});
